(function () {
  'use strict';

  // Skin Quiz: preguntas, puntos y resultados según el documento "Skin Quiz — Michelle Peters Skincare" (19/10/2026).
  // H Hypersensitive, E Eczema-prone, R Redness, A Actives, D Dry.
  const QUESTIONS = [
    {
      title: 'What’s your main skin concern?',
      text: 'Pick the one you notice most.',
      options: [
        { title: 'Redness and flushing', text: 'Cheeks that go red with heat, cold or stress', points: { R: 2 } },
        { title: 'Stinging and reacting', text: 'New products often sting or itch', points: { H: 2, A: 1 } },
        { title: 'Tightness and dryness', text: 'Tight after cleansing, flaky patches', points: { D: 2 } },
        { title: 'Itchy, flaring patches', text: 'Rough or red patches that come and go', points: { E: 2 } },
        { title: 'A bit of everything', text: 'My skin tolerates very little', points: { H: 2, R: 1 }, key: 'everything' },
      ],
    },
    {
      title: 'How does your skin feel by midday?',
      text: 'No make-up, no products. Just your skin.',
      options: [
        { title: 'Tight or flaky', text: 'Feels like it needs cream', points: { D: 2 } },
        { title: 'Warm and flushed', text: 'Pink or red, especially the cheeks', points: { R: 2 } },
        { title: 'Itchy or uncomfortable', text: 'Wants to be scratched', points: { E: 2 } },
        { title: 'Comfortable', text: 'Not tight, not shiny', points: { A: 1 } },
      ],
    },
    {
      title: 'How does your skin react to new products?',
      text: 'Redness, stinging or itching after trying something new.',
      options: [
        { title: 'Yes, almost always', text: 'Most new products sting or turn me red', points: { H: 2 }, key: 'always' },
        { title: 'Only with strong actives', text: 'Retinol, acids or vitamin C are the problem', points: { A: 2 } },
        { title: 'Sometimes', text: 'It depends on the product', points: { R: 1 } },
        { title: 'Rarely', text: 'My skin handles most things', points: { D: 1 } },
      ],
    },
    {
      title: 'Have you ever had to stop using an active?',
      text: 'Retinol, exfoliating acids or strong vitamin C.',
      options: [
        { title: 'Yes, more than once', text: 'My skin couldn’t take it', points: { A: 2 } },
        { title: 'Once', text: 'I tried, it didn’t go well', points: { A: 1 } },
        { title: 'I avoid them', text: 'I don’t dare to try', points: { H: 1 } },
        { title: 'No', text: 'Never used them or no problem', points: {} },
      ],
    },
    {
      title: 'Does your skin get patches that flare up?',
      text: 'Dry, red or itchy areas that appear and disappear.',
      options: [
        { title: 'Yes, often', text: 'Especially in winter or with stress', points: { E: 2 }, key: 'often' },
        { title: 'Sometimes', text: 'A few times a year', points: { E: 1 } },
        { title: 'No', text: 'My skin stays even', points: {} },
      ],
      pregnancyCheckbox: true,
    },
  ];

  const TIE_ORDER = ['H', 'E', 'R', 'A', 'D'];

  const PROFILES = {
    R: {
      name: 'Redness & Reactive Skin',
      tagline: 'For skin that flushes, stings or reacts easily.',
      products: ['serum', 'cream'],
      cart: { bundle: 'bundle_redness', fallback: ['serum', 'cream'] },
      am: 'Booster Serum, then Restore Cream.',
      pm: 'Booster Serum, then Restore Cream.',
      why: 'Your skin reacts before it has time to settle. The serum calms and comforts first; the cream seals that calm in and protects through the day. No essential oils, so nothing to set the redness off.',
      crossSell: 'Complete your ritual with the Gentle Glow Cleanser.',
      tag: 'quiz_redness',
    },
    H: {
      name: 'Hypersensitive Skin',
      tagline: 'For skin that tolerates very little. Zero essential oils, zero sulfates.',
      products: ['cleanser', 'serum', 'cream'],
      cart: { bundle: 'bundle_ritual', fallback: ['cleanser', 'serum', 'cream'] },
      am: 'Cleanse, Boost, Restore.',
      pm: 'Cleanse, Boost, Restore.',
      why: 'When skin tolerates very little, the safest thing is one calm routine with nothing new sneaking in. Three steps, one logic, every formula made for reactive skin. Cleanse. Boost. Restore. Nothing else.',
      crossSell: '',
      tag: 'quiz_hypersensitive',
    },
    D: {
      name: 'Dry & Tight Skin',
      tagline: 'For skin that feels tight after cleansing.',
      products: ['cream'],
      cart: { fallback: ['cream'] },
      am: 'Restore Cream after cleansing.',
      pm: 'Restore Cream, a little more generously.',
      why: 'Tightness is skin asking for comfort, not for more actives. The Restore Cream nourishes and softens, and leaves a lifting sensation without any sting.',
      crossSell: 'Add the Gentle Glow Cleanser so cleansing stops pulling at your skin.',
      tag: 'quiz_dry',
    },
    A: {
      name: 'Skin That Reacts to Actives',
      tagline: 'For skin that can’t tolerate retinol, acids or strong vitamin C.',
      products: ['serum'],
      cart: { fallback: ['serum'] },
      am: 'Booster Serum under your usual moisturiser.',
      pm: 'Booster Serum on clean skin.',
      why: 'Your skin wants results, not a fight. The Booster Serum works with Swiss alpine actives that calm, protect and strengthen, with none of the actives that made you stop before. Use it every day, morning and night.',
      crossSell: 'Pair it with the Restore Cream for a complete calm routine.',
      tag: 'quiz_actives',
    },
    E: {
      name: 'Prone to Eczema & Dermatitis',
      tagline: 'A calm routine for skin prone to flare-ups.',
      products: ['cleanser', 'cream'],
      cart: { fallback: ['cleanser', 'cream'] },
      am: 'Gentle Glow Cleanser, then Restore Cream.',
      pm: 'Gentle Glow Cleanser, then Restore Cream.',
      why: 'For skin prone to flare-ups, the cleanser is half the routine. Ours cleans without sulfates, so it doesn’t strip. The Restore Cream then comforts and protects the skin barrier through the day and night.',
      crossSell: 'Once your skin feels settled, add the Booster Serum.',
      tag: 'quiz_eczema_prone',
    },
  };

  const STEP_LABELS = { cleanser: 'Cleanse', serum: 'Boost', cream: 'Restore' };

  // answers: índice de la opción elegida en cada pregunta (0-based).
  function score(answers) {
    const points = { H: 0, E: 0, R: 0, A: 0, D: 0 };
    const keys = [];
    answers.forEach((optionIndex, questionIndex) => {
      const option = QUESTIONS[questionIndex] && QUESTIONS[questionIndex].options[optionIndex];
      if (!option) return;
      Object.keys(option.points).forEach((profile) => (points[profile] += option.points[profile]));
      keys[questionIndex] = option.key;
    });

    const top = TIE_ORDER.reduce((best, profile) => (points[profile] > points[best] ? profile : best), TIE_ORDER[0]);

    // Regla 1: "A bit of everything" + "Yes, almost always" → Hypersensitive.
    if (keys[0] === 'everything' && keys[2] === 'always') return { profile: 'H', points, rule: 'tolerates-little' };

    // Regla 2: "Yes, often" en Q5 → Eczema-prone, salvo que Hypersensitive gane con 2 puntos o más sobre Eczema-prone.
    if (keys[4] === 'often') {
      const hypersensitiveWins = top === 'H' && points.H - points.E >= 2;
      return { profile: hypersensitiveWins ? 'H' : 'E', points, rule: 'flare-ups' };
    }

    return { profile: top, points, rule: null };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { QUESTIONS, PROFILES, TIE_ORDER, score };
    return;
  }

  const OPEN_HASH = '#skin-quiz';

  const escapeHtml = (value) =>
    String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  class SkinQuiz extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      try {
        this.config = JSON.parse(this.querySelector('[data-skin-quiz-config]').textContent);
      } catch (error) {
        this.config = { products: {} };
      }

      this.body = this.querySelector('[data-skin-quiz-body]');
      this.status = this.querySelector('[data-skin-quiz-status]');
      this.progress = this.querySelector('[data-skin-quiz-progress]');
      this.backButton = this.querySelector('[data-skin-quiz-back]');

      this.querySelector('[data-skin-quiz-close]').addEventListener('click', () => this.close());
      this.backButton.addEventListener('click', () => this.back());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(`a[href$="${OPEN_HASH}"], [data-skin-quiz-open]`);
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      });
      window.addEventListener('hashchange', () => {
        if (window.location.hash === OPEN_HASH) this.open();
      });
      if (window.location.hash === OPEN_HASH) this.open();
    }

    open(trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.trigger = trigger || document.activeElement;
      this.reset();
      this.hidden = false;
      document.documentElement.classList.add('skin-quiz-open');
      requestAnimationFrame(() => this.classList.add('is-visible'));
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-visible');
      document.documentElement.classList.remove('skin-quiz-open');
      this.hidden = true;
      if (window.location.hash === OPEN_HASH) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus({ preventScroll: true });
    }

    reset() {
      this.answers = [];
      this.pregnant = false;
      this.step = 0;
      this.renderQuestion();
    }

    back() {
      if (this.step === 0) return this.close();
      this.step -= 1;
      this.answers.length = this.step;
      this.renderQuestion();
    }

    setHeader(label, progress) {
      this.status.textContent = label;
      this.progress.style.setProperty('--skin-quiz-progress', `${progress}%`);
    }

    renderQuestion() {
      const question = QUESTIONS[this.step];
      const total = QUESTIONS.length;
      this.setHeader(`Question ${this.step + 1} of ${total}`, (this.step / total) * 100);

      const options = question.options
        .map(
          (option, index) => `
          <button type="button" class="skin-quiz__option${this.answers[this.step] === index ? ' is-selected' : ''}" data-option="${index}">
            <span class="skin-quiz__option-title">${escapeHtml(option.title)}</span>
            <span class="skin-quiz__option-text">${escapeHtml(option.text)}</span>
          </button>`
        )
        .join('');

      const checkbox = question.pregnancyCheckbox
        ? `<label class="skin-quiz__checkbox">
            <input type="checkbox" data-pregnant${this.pregnant ? ' checked' : ''}>
            <span>I’m pregnant or breastfeeding</span>
          </label>`
        : '';

      this.body.innerHTML = `
        <div class="skin-quiz__question">
          <p class="skin-quiz__eyebrow">Your skin</p>
          <h2 class="skin-quiz__title" id="SkinQuizTitle" tabindex="-1">${escapeHtml(question.title)}</h2>
          <p class="skin-quiz__subtitle">${escapeHtml(question.text)}</p>
          <div class="skin-quiz__options">${options}</div>
          ${checkbox}
        </div>`;

      this.body.querySelectorAll('[data-option]').forEach((button) =>
        button.addEventListener('click', () => this.choose(parseInt(button.dataset.option, 10), button))
      );
      const pregnant = this.body.querySelector('[data-pregnant]');
      if (pregnant) pregnant.addEventListener('change', () => (this.pregnant = pregnant.checked));

      this.scrollTop = 0;
      this.body.querySelector('.skin-quiz__title').focus({ preventScroll: true });
    }

    choose(optionIndex, button) {
      if (this.choosing) return;
      this.choosing = true;
      this.answers[this.step] = optionIndex;
      this.body.querySelectorAll('[data-option]').forEach((item) => item.classList.toggle('is-selected', item === button));

      setTimeout(() => {
        this.choosing = false;
        if (this.step < QUESTIONS.length - 1) {
          this.step += 1;
          this.renderQuestion();
        } else {
          this.step = QUESTIONS.length;
          this.renderResult();
        }
      }, 280);
    }

    product(key) {
      return (this.config.products || {})[key] || null;
    }

    renderResult() {
      this.result = score(this.answers);
      const profile = PROFILES[this.result.profile];
      this.setHeader('Your routine', 100);

      const cards = profile.products
        .map((key) => {
          const product = this.product(key);
          if (!product) return '';
          const image = product.image
            ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" width="${product.image_width || ''}" height="${product.image_height || ''}" loading="lazy">`
            : '';
          return `
            <a class="skin-quiz__product" href="${escapeHtml(product.url)}">
              <span class="skin-quiz__product-media">${image}</span>
              <span class="skin-quiz__product-step">${STEP_LABELS[key]}</span>
              <span class="skin-quiz__product-title">${escapeHtml(product.title)}</span>
              ${product.size ? `<span class="skin-quiz__product-size">${escapeHtml(product.size)}</span>` : ''}
            </a>`;
        })
        .join('');

      // Sin lista de Klaviyo configurada no se muestra el formulario: así nunca se promete un email que no sale.
      const klaviyo = this.config.klaviyo || {};
      const keepForm =
        klaviyo.public_key && klaviyo.list_id
          ? `<form class="skin-quiz__keep" data-keep-form novalidate>
            <h3 class="skin-quiz__keep-title">Keep your routine</h3>
            <p class="skin-quiz__keep-text">We’ll send your routine and our free guide to calmer skin. No discounts, no noise.</p>
            <div class="skin-quiz__keep-fields">
              <label class="visually-hidden" for="SkinQuizEmail">Your email</label>
              <input type="email" id="SkinQuizEmail" name="email" placeholder="Your email" autocomplete="email" required>
              <button type="submit" class="skin-quiz__button skin-quiz__button--gold">Send my routine</button>
            </div>
            <p class="skin-quiz__message" data-keep-message role="status"></p>
          </form>`
          : '';

      const pregnantLine = this.pregnant
        ? '<p class="skin-quiz__note">None of our formulas contain retinol or exfoliating acids. If in doubt, show the ingredient list to your doctor or midwife.</p>'
        : '';

      this.body.innerHTML = `
        <div class="skin-quiz__result">
          <p class="skin-quiz__eyebrow">Your skin profile</p>
          <h2 class="skin-quiz__result-title" id="SkinQuizTitle" tabindex="-1">${escapeHtml(profile.name)}</h2>
          <p class="skin-quiz__tagline">${escapeHtml(profile.tagline)}</p>

          <div class="skin-quiz__products skin-quiz__products--${profile.products.length}">${cards}</div>

          <div class="skin-quiz__actions">
            <button type="button" class="skin-quiz__button skin-quiz__button--light" data-add-routine>Add routine to bag</button>
            <p class="skin-quiz__message" data-add-message role="status"></p>
            ${profile.crossSell ? `<p class="skin-quiz__cross-sell">${escapeHtml(profile.crossSell)}</p>` : ''}
          </div>

          <div class="skin-quiz__boxes">
            <div class="skin-quiz__box">
              <p class="skin-quiz__box-title">Your routine</p>
              <p class="skin-quiz__routine"><span>AM</span>${escapeHtml(profile.am)}</p>
              <p class="skin-quiz__routine"><span>PM</span>${escapeHtml(profile.pm)}</p>
            </div>
            <div class="skin-quiz__box">
              <p class="skin-quiz__box-title">Why this fits</p>
              <p class="skin-quiz__why">${escapeHtml(profile.why)}</p>
              ${pregnantLine}
            </div>
          </div>

          <p class="skin-quiz__facts">Zero essential oils · Zero sulfates · Made in Switzerland</p>

          ${keepForm}

          <p class="skin-quiz__disclaimer">This quiz is a guide to help you choose, not medical advice.</p>
          <button type="button" class="skin-quiz__button skin-quiz__button--outline" data-restart>Start again</button>
        </div>`;

      this.body.querySelector('[data-add-routine]').addEventListener('click', (event) => this.addRoutine(event.currentTarget));
      const form = this.body.querySelector('[data-keep-form]');
      if (form) form.addEventListener('submit', (event) => this.keepRoutine(event));
      this.body.querySelector('[data-restart]').addEventListener('click', () => this.reset());

      this.scrollTop = 0;
      this.body.querySelector('.skin-quiz__result-title').focus({ preventScroll: true });
    }

    cartItems() {
      const cart = PROFILES[this.result.profile].cart;
      const bundle = cart.bundle && this.product(cart.bundle);
      if (bundle && bundle.available) return [{ id: bundle.variant_id, quantity: 1 }];
      return cart.fallback
        .map((key) => this.product(key))
        .filter((product) => product && product.available)
        .map((product) => ({ id: product.variant_id, quantity: 1 }));
    }

    async addRoutine(button) {
      const message = this.body.querySelector('[data-add-message]');
      const items = this.cartItems();
      message.textContent = '';
      if (!items.length) {
        message.textContent = 'This routine is not available right now.';
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // Mismo flujo que el botón de compra del tema: pedir las secciones del carrito para refrescar el cajón.
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || response.statusText);

        const cart = await (await fetch(`${root}cart.js`)).json();
        cart.sections = state.sections;
        const drawer = this.config.cart_type === 'drawer' && document.querySelector('cart-drawer');
        this.close();

        try {
          if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
        } catch (error) {
          console.error('Skin Quiz:', error);
        }
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (error) {
        message.textContent = 'We couldn’t add your routine. Please try again.';
        console.error('Skin Quiz:', error);
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }

    async keepRoutine(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const input = form.querySelector('input[type="email"]');
      const message = form.querySelector('[data-keep-message]');
      const button = form.querySelector('button[type="submit"]');
      const email = input.value.trim();

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        message.textContent = 'Please enter a valid email.';
        input.focus();
        return;
      }

      const profile = PROFILES[this.result.profile];
      const properties = {
        skin_quiz_profile: profile.tag,
        skin_quiz_result: profile.name,
        skin_quiz_pregnant_or_breastfeeding: this.pregnant,
        skin_quiz_completed_at: new Date().toISOString(),
      };
      const answers = this.answers.map((optionIndex, questionIndex) => QUESTIONS[questionIndex].options[optionIndex].title);
      const klaviyo = this.config.klaviyo || {};
      // Alta en la lista del quiz + evento "Completed Skin Quiz" para los flujos por perfil.
      const requests = [
        {
          url: 'subscriptions',
          body: {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Skin Quiz',
                profile: { data: { type: 'profile', attributes: { email, properties } } },
              },
              relationships: { list: { data: { type: 'list', id: klaviyo.list_id } } },
            },
          },
        },
        {
          url: 'events',
          body: {
            data: {
              type: 'event',
              attributes: {
                properties: Object.assign({ answers, products: profile.products.map((key) => (this.product(key) || {}).title) }, properties),
                metric: { data: { type: 'metric', attributes: { name: 'Completed Skin Quiz' } } },
                profile: { data: { type: 'profile', attributes: { email, properties } } },
              },
            },
          },
        },
      ];

      button.disabled = true;
      message.textContent = '';

      try {
        for (const request of requests) {
          const response = await fetch(`https://a.klaviyo.com/client/${request.url}/?company_id=${encodeURIComponent(klaviyo.public_key)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify(request.body),
          });
          if (!response.ok) throw new Error(`Klaviyo ${request.url} ${response.status}`);
        }
        form.classList.add('is-sent');
        message.textContent = 'Done. Your routine is on its way to your inbox.';
      } catch (error) {
        button.disabled = false;
        message.textContent = 'Something went wrong. Please try again.';
        console.error('Skin Quiz:', error);
      }
    }
  }

  if (!customElements.get('skin-quiz')) customElements.define('skin-quiz', SkinQuiz);
})();
